import React, { useState, useEffect } from "react";
import { Modal, Input, Radio, Button, Checkbox } from "antd";
import classNames from "classnames";
import IconButton from "../IconButton/IconButton.jsx";
import DatePicker from "../DatePicker/DatePicker.jsx";
import classnames from "classnames";
import { getFullName, isRTL } from '../../../services/userModel.js';
import {prepareEndDate, prepareStartDate, setStartTime} from "../../../utils/convertTime.js";
import moment from "moment/moment.js";
import NumberInput from "../NumberInput/index.js";
import { useDispatch } from 'react-redux';
import UsersPopup from '../ControlCentersManagersList/index.js';
import { POPUP_ITEM_TYPE, USER_FILTER_ROLES } from '../../../utils/enums.js';

const TableFilterModal = ({ visible, onClose, dataColumns, onApply, filters, filter, t }) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [selectedColumn, setSelectedColumn] = useState(null);

  const [operator, setOperator] = useState(null);
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");
  const [lookupValue, setLookupValue] = useState([]);
  const [minValue, setMinValue] = useState(null);
  const [maxValue, setMaxValue] = useState(null);

  const [colInit, setColInit] = useState(0);
  const [isCourierPopupOpen, setIsCourierPopupOpen] = useState(false);

  const selectedColumnFilterKey = JSON.stringify(filters?.[selectedColumn?.accessor] ?? null);
  const filterKey = JSON.stringify(filter ?? null);
  const limitsKey = JSON.stringify(filters?.date ?? null);

  useEffect(() => {
    if (colInit !== 2) {
      const firstColumn = dataColumns.find(c => c.type);
      setSelectedColumn(firstColumn);
      setColInit(colInit+1);
    }
  }, [colInit, dataColumns]);

  const getDefaultOperator = () => {
    const defaultOperator = {
      'string': 'contains',
      'number': 'equal',
      'date': 'between',
    }
    return (defaultOperator[selectedColumn?.type] || defaultOperator.string);
  }

  useEffect(() => {
    if(!selectedColumn) return;

    const columnFilter = filters?.[selectedColumn.accessor];
    setSearch('');
    if(columnFilter) {
        setOperator(columnFilter.operator);
        setValue(columnFilter.value);
        setValue2(columnFilter.value2);
        setLookupValue(Array.isArray(columnFilter.value) ? columnFilter.value : []);
    } else {
      setValue(null);
      setValue2(null);
      setOperator(getDefaultOperator());
      setLookupValue([]);
    }
    // eslint-disable-next-line
  }, [selectedColumn, selectedColumnFilterKey]);


  useEffect(() => {
    if(!selectedColumn) return;
    const dataFilter = filters?.date;
    setMinValue(selectedColumn.minFilterAccessorValue && dataFilter && selectedColumn.limitMinMax ? dataFilter[selectedColumn.minFilterAccessorValue] : null);
    setMaxValue(selectedColumn.maxFilterAccessorValue && dataFilter && selectedColumn.limitMinMax ? dataFilter[selectedColumn.maxFilterAccessorValue] : null);

    if((selectedColumn.minFilterAccessorValue || selectedColumn.maxFilterAccessorValue) && dataFilter && selectedColumn.limitMinMax && selectedColumn.type === "date") {
      const min = dataFilter[selectedColumn.minFilterAccessorValue] || dataFilter["value2"];
      const max = dataFilter[selectedColumn.maxFilterAccessorValue] || dataFilter["value2"];
      const isBetween = moment(new Date()).isBetween(min || new Date(), max || new Date());
      const initDate = isBetween ? filter.start || prepareStartDate(setStartTime(new Date())) : (min || filter.start);
      const initDateEnd = isBetween
        ? filter.end || filter.start || prepareEndDate(new Date())
        : filter.end || prepareEndDate(moment(initDate).add(1, 'd'));
      !value && setValue(initDate);
      !value2 && setValue2(initDateEnd);
    }
    // eslint-disable-next-line
  }, [filterKey, limitsKey, selectedColumn]);

  const handleOnReset = () => {
    setSearch('');
  }

  const CourierItem = () => {
    const handleApply = () => {
      const filterData = {
        accessor: selectedColumn.accessor,
        operator: "is",
        value: lookupValue,
        type: selectedColumn.type
      };
      onApply(filterData);
      setColInit(0);
      onClose();
    }
    const handleOnSetLookup = (user) => {
      setLookupValue([{key: user.userId, value: getFullName(user)}]);
    }
    return (
      <div>
        <UsersPopup
          courierName={lookupValue?.[0]?.value}
          onPropChange={(_, user) => handleOnSetLookup(user)}
          roles={[USER_FILTER_ROLES.courier]}
          itemType={POPUP_ITEM_TYPE.shiftsFilterItem}
          parentOpenState={isCourierPopupOpen}
          onParentOpenStateChange={setIsCourierPopupOpen}
        />
        <div className="filterActionsButton">
          <Button key="cancel" onClick={handleClose} className="cancel">
            {t("orders.CANCEL_FILTER_BUTTON")}
          </Button>
          <Button key="apply" type="primary" onClick={handleApply} className="apply">
            {t("orders.APPLY_FILTER_BUTTON")}
          </Button>
        </div>
      </div>
    )
  }


  const handleApply = () => {
    if (!selectedColumn || !operator) return;

    if(selectedColumn.type === "number" && (value < 0 || value2 < 0)) {
      return;
    }

    const filterData = {
      accessor: selectedColumn.accessor,
      operator,
      type: selectedColumn.type
    };

    switch (selectedColumn.type) {
      case "string":
        if (operator === "is" || operator === "not" || operator === "contains") {
          filterData.value = value;
        }
        break;

      case "number":
        if (operator === "between") {
          filterData.value = value;
          filterData.value2 = value2;
        } else {
          filterData.value = value;
        }
        break;

      case "date":
        if (operator === "between") {
          filterData.value = value;
          filterData.value2 = value2;
        } else if(operator === "before") {
          filterData.value2 = value2;
        } else {
          filterData.value = value;
        }
        break;

      case "lookup":
        filterData.operator = 'is';
        filterData.value = lookupValue;
        if(selectedColumn?.lookupOnApply) {
          dispatch(selectedColumn.lookupOnApply(lookupValue));
        }
        break;

      default:
        break;
    }

    onApply(filterData);
    setColInit(0);
    setIsCourierPopupOpen(false);
    onClose();
  };

  const handleClose = () => {
    handleOnReset();
    setColInit(0);
    setIsCourierPopupOpen(false);
    onClose();
  }

  const handleOnPaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    setValue(pastedText.trim());
  }

  const handleOnPasteToSearch = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text');
    setSearch(pastedText.trim());
  }

  const renderActionButtons = () => (
    <div className="filterActionsButton">
      <Button key="cancel" onClick={handleClose} className="cancel">
        {t("orders.CANCEL_FILTER_BUTTON")}
      </Button>
      <Button key="apply" type="primary" onClick={handleApply} className="apply">
        {t("orders.APPLY_FILTER_BUTTON")}
      </Button>
    </div>
  )

  const renderStringFilter = () => (
    <div className="filterForm">
      <Radio.Group
        className="radioGroup"
        onChange={(e) => {
          setOperator(e.target.value);
          setValue("");
          setValue2("");
        }}
        value={operator}
      >
        <Radio value="contains">{t("orders.operators.CONTAINS")}</Radio>
        {(operator === "contains") && (
          <Input
            onPaste={handleOnPaste}
            className="stringInput"
            placeholder={t("orders.CENTER_TEXT_FILTER_LABEL")}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
        <Radio value="is">{t("orders.operators.IS")}</Radio>
        {(operator === "is") && (
          <Input
            onPaste={handleOnPaste}
            className="stringInput"
            placeholder={t("orders.CENTER_TEXT_FILTER_LABEL")}
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        )}
        <Radio value="any_value">{t("orders.operators.HAS_ANY_VALUE")}</Radio>
        <Radio value="empty">{t("orders.operators.EMPTY")}</Radio>
      </Radio.Group>
      {renderActionButtons()}
    </div>
  );

  const renderNumberFilter = () => (
    <div className="filterForm">
      <Radio.Group
        className="radioGroup"
        onChange={(e) => {
          setOperator(e.target.value);
          setValue("");
          setValue2("");
        }}
        value={operator}
      >
        <Radio value="equal">{t("orders.operators.IS_EQUAL_TO")}</Radio>
        {operator === "equal" && (
          <NumberInput
            type={'number'}
            className="numberInput"
            placeholder={t('orders.NUMBER_FILTER_LABEL')}
            value={value}
            onChange={(value) => setValue(Math.abs(value))}
          />
        )}
        <Radio value="between">{t("orders.operators.IS_BETWEEN")}</Radio>
        {operator === "between" && (
          <div style={{ display: "flex", "flex-wrap": "wrap" }}>
            <NumberInput
              type={'number'}
              className="numberInput numberInputBetween"
              placeholder={t('orders.NUMBER_MIN_FILTER_LABEL')}
              value={value}
              onChange={(value) => setValue(Math.abs(value))}
            />
            <NumberInput
              type={'number'}
              className="numberInput"
              placeholder={t('orders.NUMBER_MAX_FILTER_LABEL')}
              value={value2}
              onChange={(value) => setValue2(Math.abs(value))}
            />
          </div>
        )}
        <Radio value="greater">{t("orders.operators.IS_GREATER_THAN")}</Radio>
        {operator === "greater" && (
          <NumberInput
            type={'number'}
            className="numberInput"
            placeholder={t('orders.NUMBER_FILTER_LABEL')}
            value={value}
            onChange={(value) => setValue(Math.abs(value))}
          />
        )}
        <Radio value="less">{t("orders.operators.IS_LASS_THAN")}</Radio>
        {operator === "less" && (
          <NumberInput
            type={'number'}
            className="numberInput"
            placeholder={t('orders.NUMBER_FILTER_LABEL')}
            value={value}
            onChange={(value) => setValue(Math.abs(value))}
          />
        )}

      </Radio.Group>
      {renderActionButtons()}
    </div>
  );

  const renderDateFilter = () => (
    <div className="filterForm">
      <Radio.Group
        className="radioGroup"
        onChange={(e) => {
          const isBetween = moment(new Date()).isBetween(minValue, maxValue);
          const initDate = isBetween ? (filter.start || prepareStartDate(setStartTime(new Date()))) : (minValue || filter.start || prepareStartDate(setStartTime(new Date())));
          const initDateEnd = isBetween ? (filter.end || filter.start || prepareEndDate(new Date())) : (filter.end || prepareEndDate(moment(initDate).add(1, 'd')));
          setOperator(e.target.value);
          !value && setValue(initDate);
          if(e.target.value === "between" || e.target.value === "before") {
            !value2 && setValue2(initDateEnd);
            if(e.target.value === "before") {
              setValue(null);
            }
          } else {
            setValue2(null);
          }
        }}
        value={operator}
      >
        <Radio value="between">{t("orders.operators.IS_BETWEEN")}</Radio>
        {operator === "between" && (
          <div style={{ display: "flex", "flex-wrap": "wrap" }}>
            <DatePicker
                updateValueByParent
                classNames="numberInput numberInputBetween"
                showTimeControl
                maxDate={maxValue}
                minDate={minValue}
                value={value}
                placeholder={t("orders.DATE_START_FILTER_LABEL")}
                onSave={(date) => setValue(date)}
            />
            <DatePicker
                updateValueByParent
                classNames="numberInput"
                showTimeControl
                maxDate={maxValue}
                minDate={minValue}
                value={value2}
                placeholder={t("orders.DATE_END_FILTER_LABEL")}
                onSave={(date) => setValue2(date)}
            />
          </div>
        )}
        {!selectedColumn.shortFilter && (<>
          <Radio value="before">{t("orders.operators.EARLIER_THEN")}</Radio>
          {operator === "before" && (
            <DatePicker
              updateValueByParent
              classNames="numberInput"
              showTimeControl
              maxDate={maxValue}
              minDate={minValue}
              value={value2}
              placeholder={t("orders.DATE_FILTER_LABEL")}
              onSave={(date) => setValue2(date)}
            />
          )}
          <Radio value="after">{t("orders.operators.LATER_THEN")}</Radio>
          {operator === "after" && (
            <DatePicker
              updateValueByParent
              classNames="numberInput"
              showTimeControl
              maxDate={maxValue}
              minDate={minValue}
              value={value}
              placeholder={t("orders.DATE_FILTER_LABEL")}
              onSave={(date) => setValue(date)}
            />
          )}
        </>)}
      </Radio.Group>
      {renderActionButtons()}
    </div>
  );

  const renderLookupFilter = () => {
    const options = (selectedColumn.lookupOptions() || []).filter(item => item.value.toLowerCase().includes(search.toLowerCase()));

    const handleSelectAll = () => {
      if (lookupValue.length === options.length) {
        setLookupValue([]);
      } else {
        setLookupValue(options);
      }
    };

    const handleOnChangeLookup = (opt) => {
      if(lookupValue.map(l => l.key).includes(opt.key)) {
        setLookupValue(lookupValue.filter(lookupValue => lookupValue.key !== opt.key));
      } else if(!(selectedColumn.maxLookupQuantity && lookupValue.length === selectedColumn.maxLookupQuantity)) {
        setLookupValue(lookupValue.concat(opt));
      }
    }

    const shouldDisableOption = selectedColumn.maxLookupQuantity && lookupValue.length === selectedColumn.maxLookupQuantity;

    return (
      <div className="filterForm">
        <div className="lookupGroup">
          <div className="ant-column-filter-dropdown">
            <input
                onPaste={handleOnPasteToSearch}
                placeholder={t("orders.SEARCH_LABEL")}
                type="text"
                className={classNames("searchInput")}
                value={search}
                onChange={({ target }) => setSearch(target.value)}
            />
            <IconButton isIcon iconName={'crossCloseRounded'} onClick={handleOnReset}/>
          </div>
          {!selectedColumn.hideSelectAll && (
            <div className="lookupSelectAll">
              <Checkbox
                checked={lookupValue.length === options.length && options.length > 0}
                onChange={handleSelectAll}
              >
                {lookupValue.length === options.length ? t("orders.DESELECT_ALL_FILTER") : t("orders.SELECT_ALL_FILTER")}
              </Checkbox>
            </div>
          )}

          {selectedColumn.hideSelectAll && !!lookupValue?.length && (
            <div className="lookupSelectAll" onClick={() => setLookupValue([])}>
              <span className={'deselectAll'}>
                {t("orders.DESELECT_ALL_FILTER")}
              </span>
            </div>
          )}

          <Checkbox.Group
            className="lookupCheckboxGroup"
            value={lookupValue.map(opt => opt.key)}
          >
            {options.map((opt) => (
              <div key={opt.key} className={classNames("lookupItem", {disableOption: shouldDisableOption})}>
                <Checkbox value={opt.key} onChange={() => handleOnChangeLookup(opt)}>{opt.value}</Checkbox>
              </div>
            ))}
          </Checkbox.Group>
        </div>
        {renderActionButtons()}
      </div>
    );
  };

  const renderFilterForm = () => {
    if (!selectedColumn) {
      return <div style={{ padding: 16 }}>{t("orders.SELECT_COLUMN_TEXT")}</div>;
    }

    switch (selectedColumn.type) {
      case "string":
        return renderStringFilter();
      case "number":
        return renderNumberFilter();
      case "date":
        return renderDateFilter();
      case "lookup":
        if(selectedColumn.accessor === "courier") {
          return CourierItem();
        }
        return renderLookupFilter();
      default:
        return <div />;
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      className="tableFilterModal"
      closable={false}
    >
      <div className={classnames("tableFilterModal__content", {rtl: isRTL()})}>
        <div className="tableFilterModal__left">
          <div>
            {dataColumns
                .filter((col) => col.type && col.accessor !== "actions" && !col.alwaysHidden)
                .filter((col) => col.search)
                .map((col) => (
                    <div
                        key={col.accessor}
                        className={
                            "columnItem " +
                            (selectedColumn?.accessor === col.accessor ? "columnItem--active" : "")
                        }
                        onClick={() => {
                          setSelectedColumn(col);
                          setOperator(null);
                          setValue("");
                          setValue2("");
                          setLookupValue([]);
                        }}
                    >
                      {col.title}
                    </div>
                ))}
          </div>
        </div>

        <div className="tableFilterModal__right">
          {renderFilterForm()}
        </div>
      </div>
    </Modal>
  );
};

export default TableFilterModal;
